<template>
    <div class="footer">
        <div class="container">
            <div class="footer-top">
                <div class="footer-left">
                    <a href="#" class="footer-logo">
                        <img src="../../assets/all/default_logo.svg" alt="">
                    </a>
                    <nav class="footer-menu">
                        <ul class="footer-list">
                            <li><a href="https://greenclinic.kz/ru/o-nas/">О нас</a></li>
                            <li><a href="https://greenclinic.kz/ru/news/">Новости</a></li>
                            <li><a href="https://greenclinic.kz/ru/departments/">Отделения</a></li>
                            <li><a href="https://greenclinic.kz/ru/dokumentacziya/">Документация</a></li>
                            <li><a href="https://greenclinic.kz/ru/kontakty/">Контакты</a></li>
                        </ul>
                    </nav>
                </div>
                <div class="footer-social">
                    <a href="https://www.instagram.com/greenclinic_astana/" class="footer-social__item">
                        <img src="../../assets/icons/insta.svg" alt="" class="footer-social__img">
                    </a>
                    <a href="https://api.whatsapp.com/send?phone=77768983800&text=&source=&data="
                        class="footer-social__item">
                        <img src="../../assets/icons/whats-app.svg" alt="" class="footer-social__img">
                    </a>
                    <a href="https://www.facebook.com/greenclinicastana" class="footer-social__item">
                        <img src="../../assets/icons/facebook.svg" alt="" class="footer-social__img">
                    </a>
                </div>
            </div>
            <div class="footer-bottom">

                <p style="background-image: url(../../assets/all/default_logo.svg);background-repeat: no-repeat;"
                    class="footer__address">г. Астана, ул. Сарайшык 11/1 (филиал)<br>г. Астана, ул. Хусейн бен Талал
                    25/1</p>

                <div style="background-image: url(../../assets/all/default_logo.svg);background-repeat: no-repeat;"
                    class="footer-phone">
                    <a href="tel:+77172797722" class="footer-phone__item">+7 (7172) 79 77 22</a>
                    <a href="tel:+77710335559" class="footer-phone__item">+7(771)-033-55-59 <span>(Филиал «Green clinic
                            Saraishyk»)</span></a>
                    <a href="tel:+77000211211" class="footer-phone__item">+7 7000 211 211 <span>(по прикреплению
                            ПМСП)</span></a>
                    <a href="tel:+77172797717" class="footer-phone__item">+7 (7172) 79 77 17 <span>(Сотрудничества и
                            предложения)</span></a>

                </div>

                <a style="background-image: url(../../assets/all/default_logo.svg)?>/images/icon/at-sign.svg);background-repeat: no-repeat;"
                    href="mailto:info@greenclinic.kz" class="footer__email">info@greenclinic.kz</a>

                <div style="background-image: url(../../assets/all/default_logo.svg)?>/images/icon/calendar.svg);background-repeat: no-repeat;"
                    class="footer-schedule">
                    <span class="footer__schedule-item">Пн-Пт: 08:00 - 18:00</span>
                    <span class="footer__schedule-item">Сб: 09:00 - 14.00</span>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        support: String
    },
    data() {
        return {

            withSupport: [
                {
                    img: require('../../assets/logo/2.png'),
                    hover_text: 'Министерство культуры и спорта Республики Казахстан',
                },
                {
                    img: require('../../assets/logo/1.png'),
                    hover_text: 'Министерство внутренних дел Республики Казахстан',
                },
                {
                    img: require('../../assets/logo/3.png'),
                    hover_text: 'АО «НК «Kazakh Tourism» ',
                },
            ],

        }
    },
    methods: {

    },

}
</script>

<style lang="less" scoped>
@mobile: 900px;
@planshet: 1200px;

.container {
    max-width: 1470px;
    margin: 0 auto;
    padding: 0 15px;
}

.footer {
    padding: 80px 0 90px;
    background-color: #939598;
    font-family: "MontserratRegular", sans-serif;

    ul li {
        list-style: none;
    }
}

.footer-top {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding-bottom: 40px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.23);
    margin-bottom: 40px;
    @media (max-width:@planshet) {
        flex-wrap: wrap;
        justify-content: space-between;
        row-gap: 20px;
    }
}

.footer-left {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    @media (max-width:@planshet) {
        width: 100%;
    }
    @media (max-width:899px) {
        flex-wrap: wrap;
        row-gap: 20px;
    }
    @media (max-width:600px) {
        width: 50%;
    }
}

.footer-logo {
    margin-right: 95px;
}

.footer-list {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;

    li a {
        white-space: nowrap;
        color: #FFFFFF;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }
}

.footer_contact {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: -0.04em;
    color: #FFFFFF;

    a {
        text-decoration: none;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        letter-spacing: -0.04em;
        color: #FFFFFF;
        margin-top: 7px;
        display: inline-block;
    }
    @media (max-width:@planshet) {
        width: 50%;
    }
    @media (max-width:600px) {
        display: none;
    }
}

.footer__item,
.footer-list li {
    margin-right: 45px;
}

.footer__item:last-child,
.footer-list li:last-child {
    margin-right: 0;
}

.footer__link {
    font-size: 14px;
    line-height: 1rem;
    color: #FFFFFF;
    transition: all .5s;
}

.footer__link:hover {
    opacity: .7;
}

.footer-social {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    @media (max-width:@planshet) {
        width: 50%;
        justify-content: flex-end;
    }
}

.footer-social__item {
    margin-right: 30px;
    width: 24px;
    height: 24px;
}

.footer-social__item:last-child {
    margin-right: 0;
}

.footer-menu {
    @media (max-width:899px) {
        width: 100%;
    }
    @media (max-width:600px) {
        display: none;
    }
}

.footer-bottom {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    @media (max-width:@planshet) {
        flex-wrap: wrap;
        row-gap: 25px;
    }
}

.footer__address {
    font-size: 16px;
    line-height: 20px;
    font-family: 'MontserratRegular';
    font-weight: 400;
    padding-left: 40px;
    position: relative;
    color: #fff;
}

.footer__address::before {
    content: '';
    background-image: url(../../assets/icons/map-pin.svg);
    position: absolute;
    left: 0;
    background-repeat: no-repeat;
    width: 24px;
    height: 24px;
}

.footer-phone {
    position: relative;
    padding-left: 40px;
}

.footer-phone::before {
    background-image: url(../../assets/icons/phone-footer.svg);
    content: '';
    position: absolute;
    left: 0;
    background-repeat: no-repeat;
    width: 24px;
    height: 24px;
}

.footer-phone__item {
    font-size: 16px;
    line-height: 1.8rem;
    color: #fff;
    display: block;
    font-family: 'MontserratRegular', sans-serif;
    font-weight: 400;
    text-decoration: none;
    transition: 0.2s;

    &:hover {
        opacity: .7;
    }
}

.footer__email {
    font-size: 16px;
    line-height: 1.25rem;
    color: #fff;
    position: relative;
    padding-left: 40px;
    font-family: 'MontserratRegular', sans-serif;
    font-weight: 400;
    text-decoration: none;
    transition: 0.2s;

    &:hover {
        opacity: .7;
    }
}

.footer__email::before {
    background-image: url(../../assets/icons/mail-footer.svg);
    content: '';
    position: absolute;
    left: 0;
    top: 3px;
    background-repeat: no-repeat;
    width: 24px;
    height: 24px;
}

.footer-schedule {
    display: flex;
    position: relative;
    padding-left: 40px;
}

.footer-schedule::before {
    background-image: url(../../assets/icons/calendar-footer.svg);
    content: '';
    position: absolute;
    left: 0;
    background-repeat: no-repeat;
    width: 24px;
    height: 24px;
}

.footer__schedule-item {
    color: #fff;
    font-size: 16px;
    line-height: 1.25rem;
    font-family: 'MontserratRegular', sans-serif;
    font-weight: 400;
    margin-right: 15px;
}

.footer__schedule-item:last-child {
    margin-right: 0;
}

@media screen and (max-width: 350px) {}

@media screen and (max-width: 320px) {}
</style>
